import Vue from "vue";
import constants from "./constants";

export default {
  getLayerDefinitionExpressionQuery: state => {
    return layerId => {
      return state.layerDefinitionExpressions[layerId].query;
    };
  },
  getDrawPointSymbols: () => {
    return constants.DRAW_SYMBOLS_POINTS;
  },
  getMapProfile: state => {
    return themeId => {
      return state.profiles[themeId];
    };
  },
  getAddedMapProfile: state => {
    return themeId => {
      return state.mapProfiles.find(profile => profile.id === themeId);
    };
  },
  getAddedMapProfileIndex: state => {
    return themeId => {
      return state.mapProfiles.findIndex(profile => profile.id === themeId);
    };
  },
  getLayerMetadataByAddressAndIndex: state => (restAdress, restIndex) => {
    return state.layerMetadata.find(
      metadata =>
        metadata.restAdress === restAdress && metadata.restIndex === restIndex
    );
  },
  getLayerInfoByUrl: state => restAdress => {
    return state.layerInfos.find(layerInfo => layerInfo.url === restAdress);
  },
  getSublayerVisibility: state => (id, sublayerIndex) => {
    return state.profiles[id].actualVisibleLayers.includes(sublayerIndex);
  },
  getMapLayer: () => {
    return layerID => {
      return Vue.prototype.$theMapObject.findLayerById(layerID);
    };
  },
  getMapProfilesVisibleSublayerIndexes: (state, getters) => id => {
    let showAtStartupLayers = [];
    let layer = getters.getMapLayer(id);

    layer.allSublayers.items.forEach(sublayer => {
      if (sublayer.visible) {
        showAtStartupLayers.push(sublayer.id);
      }
    });

    return showAtStartupLayers;
  }
};
